import { render, staticRenderFns } from "./UserCrudSidebar.vue?vue&type=template&id=34100eac&"
import script from "./UserCrudSidebar.vue?vue&type=script&lang=js&"
export * from "./UserCrudSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports